var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("CenterOnParent", [
    _c(
      "div",
      {
        staticClass: "jumbotron",
        staticStyle: {
          "background-color": "var(--code-background-color)",
          color: "var(--code-color)"
        }
      },
      [
        _c("div", { staticClass: "d-flex flex-row mb-4" }, [
          _c("i", {
            staticClass: "fa fa-poll mx-auto",
            staticStyle: { "font-size": "3em" }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "mb-2" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.$t("survey.code.pleaseEnterCodeHere")) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.code,
                expression: "code",
                modifiers: { number: true }
              }
            ],
            staticClass: "form-control",
            attrs: { type: "number", min: "0", max: "999999" },
            domProps: { value: _vm.code },
            on: {
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.moveToFirstLetterOfLastNameBox.apply(null, arguments)
              },
              input: function($event) {
                if ($event.target.composing) return
                _vm.code = _vm._n($event.target.value)
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          }),
          _vm._v(" "),
          !_vm.enableFirstLetterOfLastName
            ? _c("div", { staticClass: "input-group-append" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.moveToFirstLetterOfLastNameBox }
                  },
                  [_c("i", { staticClass: "fa fa-arrow-right" })]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.enableFirstLetterOfLastName
          ? [
              _c("div", { staticClass: "mb-2 mt-3" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "survey.code.pleaseEnterFirstCharacterOfLastNameHere"
                      )
                    ) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group mt-2" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model.number",
                      value: _vm.firstLetterOfLastName,
                      expression: "firstLetterOfLastName",
                      modifiers: { number: true }
                    }
                  ],
                  ref: "firstLetterOfLastNameBox",
                  staticClass: "form-control",
                  attrs: { type: "text", maxlength: "1" },
                  domProps: { value: _vm.firstLetterOfLastName },
                  on: {
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.$emit(
                        "input",
                        _vm.code,
                        _vm.firstLetterOfLastName
                      )
                    },
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.firstLetterOfLastName = _vm._n($event.target.value)
                    },
                    blur: function($event) {
                      return _vm.$forceUpdate()
                    }
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "input-group-append" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          return _vm.$emit(
                            "input",
                            _vm.code,
                            _vm.firstLetterOfLastName
                          )
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-right" })]
                  )
                ])
              ])
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }